import Speedyscaf from "./Speedyscaf";

export default Speedyscaf;
